import styled from 'styled-components';
import Header from 'common/Header';
import { pxToRem } from 'utils/stylingUtils';

const StyledHeader = styled(Header)`
    margin-bottom: ${pxToRem(4)};
`;

export default StyledHeader;
